import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

// Components
import { AppComponent } from './app.component';
import { CallbackComponent } from './callback/callback.component';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import { ToastComponent } from './toast/toast.component';
import { ModalComponent } from './shared/modal/modal.component';

// Feature Modules & Routing
import { SharedModule } from './shared/shared.module';
import { UserModule } from './user/user.module';
import { AuthModule } from './auth/auth.module';
import { AppRoutingModule } from './app-routing.module';

// NGRX related
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreRouterConnectingModule, RouterStateSerializer } from '@ngrx/router-store';
import { CustomRouterStateSerializer } from './shared/utils';
import { reducers, metaReducers } from './reducers';
// import { SiteEffects } from './site/store/effects/site.effects';

// Misc.
import { JwtInterceptor, ErrorInterceptor } from './_helpers';
import { environment } from '../environments/environment';
import { SiteEffects } from './site/store/effects/site.effects';

import { MsalService, MSAL_INSTANCE } from './msal';
import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';

export function MSALInstanceFactory(): IPublicClientApplication {
	return new PublicClientApplication({
		auth: {
			clientId: environment.msal.clientId,
			redirectUri: environment.msal.redirectUri,
			authority: environment.msal.authority,
			knownAuthorities: environment.msal.knownAuthorities,
			navigateToLoginRequestUrl: false,
		},
		cache: {
			cacheLocation: 'localStorage',
		},
	});
}

@NgModule({
	declarations: [AppComponent, CallbackComponent, ForbiddenComponent, ToastComponent, ModalComponent],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		FormsModule,
		AppRoutingModule,
		AuthModule,
		SharedModule,
		UserModule,
		HttpClientModule,
		StoreModule.forRoot(reducers, { metaReducers }),
		StoreRouterConnectingModule.forRoot({
			stateKey: 'router',
		}),
		EffectsModule.forRoot([SiteEffects]),
		!environment.production ? StoreDevtoolsModule.instrument() : [],
	],
	providers: [
		{ provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
		{ provide: RouterStateSerializer, useClass: CustomRouterStateSerializer },
		{
			provide: MSAL_INSTANCE,
			useFactory: MSALInstanceFactory,
		},
		MsalService,
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
